import {IsLoggedInUseCase} from '@app/core/user/application/isLoggedIn.use-case';
import {Injectable} from "@angular/core";
import {UserLocal} from "@app/core/user/domain/user.local";
import {combineLatest, Observable} from "rxjs";
import {map} from "rxjs/operators";
/**
 * Use case to determine if the current user is a guest.
 */
@Injectable({
    providedIn: 'root'
})
export class IsGuestUseCase {
    constructor(
        private userLocal: UserLocal,
        private isLoggedInUseCase: IsLoggedInUseCase
    ) { }

    execute(): Observable<boolean> {
        return combineLatest([this.userLocal.isGuest$, this.isLoggedInUseCase.execute()]).pipe(
            map(([isGuest, isLoggedIn]) => {
                return (isLoggedIn && isGuest) || !isLoggedIn
            })
        )

    }
}
